export default __webpack_public_path__ + "static/media/2736.46e45742.svg";